import React from 'react';
import Button from '@bit/gerenciatd.unifiedcomponents.button';
import TextInfo from '@bit/gerenciatd.unifiedcomponents.text-info';
import './FlyoutFooter.scss';

const COMPONENT_NAME = 'flyout-footer';
const footerButtonProps = {
  className: 'footer-button',
  segment: 'emp',
  target: '_self',
  buttonType: 'button',
  color: 'white_blue',
  size: {
    w: 'full',
    h: 'large',
  },
  font: 'bold',
  border: 'no-border-radius',
  tabletProps: {
    size: {
      w: 'medium',
    },
  },
  desktopProps: {
    size: {
      w: 'medium',
    },
  },
}

const FlyoutFooter = (props) => {
  // const { Modal } = props;
  let { taggingInfo } = props;
  if (!taggingInfo) {
    taggingInfo = {
      componentVariation: 'all',
      componentName: COMPONENT_NAME,
      componentProduct: '',
    };
  }


  return (
    <div className="Flyout-footer">
      <TextInfo {...props['TextInfo-1']} />
      <Button {...props['Button-1']} />
    </div>
  );
};

export default FlyoutFooter;
